/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {

  setVinNo(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setVinNo", payload);
  },
  setSerialNo(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setSerialNo", payload);
  },
  setWorkPattern(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setWorkPattern", payload);
  },
};
